import { Trans, useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import useTitle, { AppName } from '../../hooks/use-title'
import useLoginUrl from '../../hooks/use-login-url'
import Logo from '../../components/logo'
import { LoadingSpinner } from '../../components/loading'
import RegionSelector from '../../components/region-selector'

export default function LoginPage () {
  const { t } = useTranslation()
  useTitle(t('loginPage_title'))
  const urlQuery = useLoginUrl(null)
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  return (
    <main className='container mx-auto'>
      <div className='mt-[220px] px-10 md:px-48'>
        <Logo className='h-6' />
        <h2 className='max-w-xl text font-medium mt-8 text-white leading-5'>
          <Trans t={t} i18nKey='loginPage_welcomeText' values={{ AppName }} />
          <a
            className='ml-2 text-white italic underline'
            href='https://www.geovonic.com/geovonic-connect/'
            target='_blank' rel='noreferrer'
          >
            <Trans t={t} i18nKey='loginPage_helpLinkLabel' values={{ AppName }} />
          </a>
        </h2>
        <div className='mt-5 text-white leading-5'>
          <RegionSelector
            label={t('loginPage_selectRegionLabel')}
            redirectPath='/login'
          />
        </div>

        <a
          className='py-5 mt-14 font-bold inline-block bg-yellow-20 text-center w-72'
          href={urlQuery.data}
          data-cy='signin'
        >

          {urlQuery.isLoading
            ? <LoadingSpinner className='h-3.5' />
            : <span>{t('glob_loginButtonLabel')}</span>}
        </a>

        <div className='mt-8'>
          <a
            className='text-sm text-white text-center py-5 inline-block hover:text-gray-60'
            href={`${process.env.PUBLIC_URL ?? ''}/auth?error=change-portal-url&` + searchParams.toString()}
          >
            {t('loginPage_changePortalLabel')}
          </a>
        </div>
      </div>
    </main>
  )
}
